import { AttractionThemeTranslationsList } from '@/components/attractions/themes/translations';
import { useParams } from 'react-router-dom';

/**
 * Translations tab inside the inline theme detail. Mounted at
 * `/attractions/:id/themes/:themeId/translations` as a child of the
 * theme layout — the layout's tab strip swaps the outlet between this
 * and `<AttractionThemeOverviewTab>`.
 */
export function AttractionThemeTranslationsTab() {
  const { id: attractionId, themeId } = useParams<{
    id: string;
    themeId: string;
  }>();
  if (!attractionId || !themeId) return null;
  return (
    <AttractionThemeTranslationsList
      attractionId={attractionId}
      themeId={themeId}
      className="p-0"
    />
  );
}
